import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink">
        <Loader2 className="w-8 h-8 text-brand animate-spin" />
      </div>
    );
  }
  if (!user) {
    const fromState = { from: location.pathname };
    return <Navigate to="/login" state={fromState} replace />;
  }
  return children;
}
